import { Link } from "react-router-dom";
import { Shield, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";

export const apiErr = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return fallback;
};

export const fmtDate = (s) => (s ? new Date(s).toLocaleString() : "—");

export const WA_LABEL = {
  live_verified: { text: "LIVE · Verified", cls: "bg-emerald-100 text-emerald-800" },
  live_error: { text: "LIVE · Error", cls: "bg-rose-100 text-rose-800" },
  live_unverified: { text: "LIVE · Not tested", cls: "bg-sky-100 text-sky-800" },
  mock: { text: "MOCK (demo)", cls: "bg-amber-100 text-amber-800" },
  none: { text: "Not connected", cls: "bg-slate-100 text-slate-600" },
};

export default function SuperHeader() {
  const { user, logout } = useAuth();
  return (
    <header className="bg-gradient-to-r from-indigo-700 to-indigo-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex items-center justify-between gap-3">
        <Link to="/super-admin" className="flex items-center gap-3" data-testid="super-home-link">
          <div className="w-10 h-10 rounded-xl bg-white/20 backdrop-blur flex items-center justify-center"><Shield className="w-5 h-5" /></div>
          <div>
            <div className="text-lg font-bold">WaggleAI · Super Admin</div>
            <div className="text-xs text-indigo-100 hidden sm:block">Platform operations & tenant management</div>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          <div className="text-right text-sm hidden sm:block">
            <div className="font-medium">{user?.name}</div>
            <div className="text-xs text-indigo-200">{user?.email}</div>
          </div>
          <Button variant="ghost" onClick={logout} className="text-white hover:bg-white/10" data-testid="super-logout">
            <LogOut className="w-4 h-4 mr-1" />Sign out
          </Button>
        </div>
      </div>
    </header>
  );
}
